import { createReducer } from '../../../store.model';

import {
    ActionType,
    InitRetrieveEventAction,
    RetrieveCommitmentsAction,
    RetrieveCommitmentsResultAction,
    RetrieveEventAction,
    RetrieveEventsAction,
    RetrieveEventsResultAction,
    SaveAction,
    SaveResultAction,
    ScheduleEventClearAction,
    UpdateAction,
    UpdateResultAction,
} from './schedule-event.action';
import { defaultState, RootState } from './schedule-event.state';

const { builder, reducer } = createReducer<ActionType, RootState>(
    defaultState(),
);

builder.add<ScheduleEventClearAction>(ActionType.SCHEDULE__EVENT_CLEAR, () => {
    return defaultState();
});

builder
    .add<RetrieveCommitmentsAction>(
        ActionType.SCHEDULE__EVENT_RETRIEVE_COMMITMENTS,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: true,
                },
                userId: action.payload.userId,
            };
        },
    )
    .add<RetrieveCommitmentsResultAction>(
        ActionType.SCHEDULE__EVENT_RETRIEVE_COMMITMENTS_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: false,
                },
                currentCommitments: action.payload.commitments,
            };
        },
    );

builder
    .add<RetrieveEventsAction>(
        ActionType.SCHEDULE__EVENT_RETRIEVE_EVENTS,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: true,
                },
                userId: action.payload.userId,
                startDate: action.payload.startDate,
            };
        },
    )
    .add<RetrieveEventsResultAction>(
        ActionType.SCHEDULE__EVENT_RETRIEVE_EVENTS_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: false,
                },
                // userId: action.userId,
                // startDate: action.startDate,
                calendarEvents: action.payload.calendarEvents,
            };
        },
    );

builder
    .add<SaveAction>(ActionType.SCHEDULE__EVENT_SAVE, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                save: true,
            },
            savedEvent: null,
        };
    })
    .add<SaveResultAction>(
        ActionType.SCHEDULE__EVENT_SAVE_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    save: false,
                },
                savedEvent: action.payload.event,
            };
        },
    );

builder
    .add<InitRetrieveEventAction>(
        ActionType.SCHEDULE__EVENT_INIT_RETRIEVE_EVENT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: false,
                },
                eventId: action.payload.eventId,
            };
        },
    )
    .add<RetrieveEventAction>(
        ActionType.SCHEDULE__EVENT__RETRIEVE_EVENT_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    retrieve: false,
                },
                updateEvent: action.payload.updateEvent,
                scheduleEventFormValue: action.payload.scheduleEventFormValue,
            };
        },
    );

builder
    .add<UpdateAction>(ActionType.SCHEDULE__EVENT_UPDATE, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                save: true,
            },
            savedEvent: null,
        };
    })
    .add<UpdateResultAction>(
        ActionType.SCHEDULE__EVENT_UPDATE_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    save: false,
                },
                savedEvent: action.payload.event,
            };
        },
    );

export default {
    scheduleEvent: reducer,
};
